import React from 'react'
import { Card } from './card'
import { DonutChart } from './donut-chart'
import { LabeledNumber } from './labeled-number'
import colors from '../../../utils/colors'

const total = 61
const completed = 53
const data = [
  {name: 'Completed', value: completed},
  {name: 'Ongoing', value: total-completed}
]
const COLORS = [colors.green, '#dddddd']

const Kebijakan = ({className}) => {
  return (
    <Card className={className}>
      <div className="flex justify-between mb-8">
        <h1 className="font-primary font-bold lg:text-lg mr-8">
          Kebijakan
        </h1>
        <div className="text-primary underline text-xs lg:text-sm">View list</div>
      </div>
      <div className="flex -mx-4">
        <div className="w-1/2 px-4">
          <DonutChart width={123} height={123} data={data} total={total} colors={COLORS}/>
        </div>
        <div className="w-1/2 px-4 -ml-4">
          <div className="mb-5">
            <LabeledNumber label="Total" number={total}/>
          </div>
          <div className="flex -mx-4">
            <div className="w-1/2 px-4">
              <LabeledNumber label="Nasional" number={total-completed}/>
            </div>
            <div className="w-1/2 px-4">
              <LabeledNumber label="Daerah" number={completed}/>
            </div>
          </div>
        </div>
      </div>
      {/* <hr className="my-8"/>
      <div className="flex">
        <div className="mr-10">
          <LabeledNumber label={<div>Total<br />Beneficiaries</div>} number={2332}/>
        </div>
        <div className="">
          <LabeledNumber label={<div>Program<br />Location</div>} number={182}/>
        </div>
      </div> */}
    </Card>
  )
}

export { Kebijakan }